import { defineMessages } from 'react-intl';

export default defineMessages({
  decrementButtonMessage: {
    id: 'QuantityCounter.decrementButton.message',
    description: 'Message for the decrement button',
    defaultMessage: 'Decrement quantity',
  },
  incrementButtonMessage: {
    id: 'QuantityCounter.incrementButton.message',
    description: 'Message for the increment button',
    defaultMessage: 'Increment quantity',
  },
});
